import { CommandBlock } from "./CommandBlock";

// Lightweight renderer: splits on triple-backtick fences, renders code via CommandBlock,
// and applies basic inline formatting (bold, inline code, bullets, numbered) to prose.
export const AiMarkdown = ({ text, testid = "ai-markdown" }) => {
  if (!text) return null;
  const parts = text.split(/```/);

  return (
    <div className="space-y-3" data-testid={testid}>
      {parts.map((part, i) => {
        const isCode = i % 2 === 1;
        if (isCode) {
          const cleaned = part.replace(/^(powershell|cmd|bash|shell|ps1)\n/i, "").trim();
          return <CommandBlock key={i} code={cleaned} testid={`${testid}-code-${i}`} />;
        }
        return <Prose key={i} text={part} />;
      })}
    </div>
  );
};

const inline = (line) =>
  line
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+?)`/g, '<code class="font-mono text-sky-300 bg-secondary/60 px-1 py-0.5 rounded text-[0.85em]">$1</code>');

const Prose = ({ text }) => {
  const lines = text.split("\n").filter((l) => l.trim() !== "");
  return (
    <div className="space-y-1.5 text-sm leading-relaxed text-foreground/90">
      {lines.map((raw, idx) => {
        const line = raw.trim();
        const numbered = line.match(/^(\d+)[.)]\s+(.*)/);
        const bullet = line.match(/^[-*•]\s+(.*)/);
        const heading = line.match(/^#{1,4}\s+(.*)/);

        if (heading) {
          return (
            <p key={idx} className="font-heading font-semibold text-base text-foreground mt-2"
               dangerouslySetInnerHTML={{ __html: inline(heading[1]) }} />
          );
        }
        if (numbered) {
          return (
            <div key={idx} className="flex gap-3">
              <span className="shrink-0 h-5 w-5 mt-0.5 rounded-full bg-primary/15 text-primary grid place-items-center text-xs font-bold">
                {numbered[1]}
              </span>
              <span dangerouslySetInnerHTML={{ __html: inline(numbered[2]) }} />
            </div>
          );
        }
        if (bullet) {
          return (
            <div key={idx} className="flex gap-2.5">
              <span className="shrink-0 mt-2 h-1.5 w-1.5 rounded-full bg-primary" />
              <span dangerouslySetInnerHTML={{ __html: inline(bullet[1]) }} />
            </div>
          );
        }
        return <p key={idx} dangerouslySetInnerHTML={{ __html: inline(line) }} />;
      })}
    </div>
  );
};
